const canBrowserDoLive = function () {
    const me = this;
    const hasActiveX = function () {
        let hasActiveX = 'ActiveX' in window;
        if (hasActiveX &&
            typeof window.external.msActiveXFilteringEnabled !== 'undefined' &&
            window.external.msActiveXFilteringEnabled()) {
            hasActiveX = false;
        }
        return hasActiveX;
    };
    return (
        !!(
            navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia
        ) || hasActiveX()
    );
};
export default canBrowserDoLive;
